import type { ComponentType } from "react";

import { ThoughtActionRow } from "./ToolCallCardThoughtActionRow";
import { ToolCallCardItemRow, isItemRow } from "./ToolCallCardItemRow";
import { ExploreActionRow } from "./ToolCallCardExploreActionRow";
import {
  isGatedInternalQuery,
  isThinkToolCall,
} from "@/components/organisms/ToolCallCard/ToolCallCard.tools";
import { ToolCallCardStreaming } from "./ToolCallCardStreaming";
import type { ToolCallContent } from "./ToolCallCard.types";

type ToolCallCardChildListProps = {
  children: ToolCallContent[] | undefined;
  depth: number;
  threadIsStreaming?: boolean;
  workflowRunning?: boolean;
  ToolCallCard: ComponentType<{
    item: ToolCallContent;
    depth?: number;
    threadIsStreaming?: boolean;
  }>;
};

/** Recursively render nested tool-call and text children. */
export function ToolCallCardChildList({
  children,
  depth,
  threadIsStreaming = false,
  workflowRunning = false,
  ToolCallCard,
}: ToolCallCardChildListProps) {
  const visibleChildren = children ?? [];

  return (
    <>
      {visibleChildren.map((child) => {
        if (isThinkToolCall(child)) {
          return <ThoughtActionRow key={child.identifier} item={child} />;
        }

        if (isItemRow(child)) {
          return <ToolCallCardItemRow key={child.identifier} item={child} />;
        }

        if (child.type === "tool_call" && isGatedInternalQuery(child)) {
          return <ExploreActionRow key={child.identifier} item={child} />;
        }

        if (child.type === "tool_call") {
          return (
            <ToolCallCard
              key={child.identifier}
              item={child}
              depth={depth + 1}
              threadIsStreaming={threadIsStreaming}
            />
          );
        }

        if (child.type === "text" && (child.text || child.streamingAgentText)) {
          return (
            <ToolCallCardStreaming
              key={child.identifier}
              text={child.streamingAgentText ?? child.text ?? ""}
              isStreaming={child.isStreaming}
            />
          );
        }

        return null;
      })}
    </>
  );
}
